import type { PreviewChangedField, PreviewColumn } from '../state/api/organisationEngineSlice';

export type CellChange = { changed: true };

/**
 * Builds the per-column overlay the preview table uses to highlight cells
 * that will change on commit. Column indices come from the server-sent
 * `columns` list, so the highlight automatically follows wherever the engine
 * places each column. Each engine-flagged field maps to one column;
 * latitude and longitude are per-axis so the user sees exactly which
 * coordinate is shifting.
 */
export const buildCellChangeOverlay = (changes: PreviewChangedField[], columns: PreviewColumn[]): Record<number, CellChange> => {
    const indexByKey = new Map(columns.map((col, idx) => [col.key, idx]));
    const overlay: Record<number, CellChange> = {};
    for (const field of changes) {
        const columnIndex = indexByKey.get(field);
        if (columnIndex === undefined) continue;
        overlay[columnIndex] = { changed: true };
    }
    return overlay;
};
